var map = {
	"./OnePlus_Logo.png": 6915,
	"./acer.png": 2681,
	"./alcatel-logo.png": 8765,
	"./asus_logo.png": 5628,
	"./blackberry-logo.png": 4977,
	"./energizer-logo-500x127.png": 8477,
	"./meizu-logo.png": 193,
	"./micromax-mobile-logo.png": 1511,
	"./microsoft-logo-500x107.png": 1480,
	"./motorola-logo.png": 2853,
	"./oppo-logo.png": 6146,
	"./panasoniclogo.png": 8244,
	"./realme-logo.png": 6783,
	"./sharp-logo-500x74.png": 3165,
	"./tecno_mobile_logo_freelogovectors.net_-400x150.png": 8746,
	"./vivo-logo.png": 1249,
	"./xiaomi.png": 2267,
	"./zte-logo-500x242.png": 4087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8643;